export const animateToCart = (event, imageSrc) => {
  if (!event || !imageSrc) return;
  
  const cartIcon = document.getElementById("global-cart-icon");
  if (!cartIcon) return;

  const button = event.currentTarget;
  const buttonRect = button.getBoundingClientRect();
  const cartRect = cartIcon.getBoundingClientRect();

  // Create clone image
  const img = document.createElement("img");
  img.src = imageSrc;
  img.style.position = "fixed";
  img.style.left = `${buttonRect.left + buttonRect.width / 2}px`;
  img.style.top = `${buttonRect.top + buttonRect.height / 2}px`;
  img.style.width = "50px";
  img.style.height = "50px";
  img.style.objectFit = "cover";
  img.style.borderRadius = "50%";
  img.style.zIndex = "99999";
  img.style.transform = "translate(-50%, -50%) scale(1)";
  img.style.transition = "all 0.8s cubic-bezier(0.25, 1, 0.5, 1)";
  
  document.body.appendChild(img);

  // Trigger animation next frame
  requestAnimationFrame(() => {
    img.style.left = `${cartRect.left + cartRect.width / 2}px`;
    img.style.top = `${cartRect.top + cartRect.height / 2}px`;
    img.style.transform = "translate(-50%, -50%) scale(0.2)";
    img.style.opacity = "0.5";
  });

  // Remove element after animation
  setTimeout(() => {
    if (document.body.contains(img)) {
      document.body.removeChild(img);
    }
    
    // Add a little pop effect to the cart icon
    cartIcon.style.transform = "scale(1.3)";
    cartIcon.style.transition = "transform 0.2s ease-in-out";
    
    setTimeout(() => {
      cartIcon.style.transform = "scale(1)";
    }, 200);
    
  }, 800);
};
